module.exports = __webpack_public_path__ + "img/Barbara Van Hare.26cc881e.jpg";